<ng-container *ngIf="routeReady; else appBooting">
  <ng-container *ngIf="!isPublic && !isNotFoundRoute && !isDocs; else bareView">
    <div class="app-frame">
      <!-- Trial + announcements mount above the whole frame: each takes its own row on
           top of the sidebar + header instead of covering the header controls. -->
      <app-trial-banner></app-trial-banner>
      <app-announcement-launcher></app-announcement-launcher>
      <div class="app-layout">
        <app-sidebar *ngIf="!isWorkflowBuilder"></app-sidebar>
        <div class="app-shell">
          <app-header></app-header>
          <div class="main-content">
            <div
              #mainScroll
              [ngClass]="
                isTeamInbox || isTicketWorkspace
                  ? 'page-content-flush'
                  : 'page-content-area'
              "
              class="main-scroll"
              [class.main-scroll--flush]="isTeamInbox || isTicketWorkspace"
              [class.main-scroll--form-page]="isGeneralParamsHub"
            >
              <app-restaurant-health-panel *ngIf="!isTeamInbox && !isTicketWorkspace"></app-restaurant-health-panel>
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <app-loader></app-loader>

  <app-attribute-create-panel
    *ngIf="!isPublic && !isNotFoundRoute"
    [open]="attributePanelOpen"
    (closed)="closeAttributePanel()"
    (saved)="onAttributeSaved()"
  ></app-attribute-create-panel>

  <app-devise-manage-panel
    *ngIf="!isPublic && !isNotFoundRoute"
    [open]="devisePanelOpen"
    (closed)="closeDevisePanel()"
    (saved)="onDeviseSaved()"
  ></app-devise-manage-panel>

  <!-- Public routes and standalone not-found (no sidebar/header) -->
  <ng-template #bareView>
    <router-outlet></router-outlet>
  </ng-template>
</ng-container>

<ng-template #appBooting>
  <div class="app-bootstrap-loader" role="status" aria-live="polite">
    <div class="dashy-loader" aria-hidden="true">
      <span class="dashy-loader__ring"></span>
      <img
        src="assets/iconLogo.png"
        alt=""
        class="dashy-loader__logo"
      />
    </div>
    <span class="sr-only">Loading...</span>
  </div>
</ng-template>
